import { render, staticRenderFns } from "./AppraisalQuestion.vue?vue&type=template&id=166bb80a&scoped=true"
import script from "./AppraisalQuestion.vue?vue&type=script&lang=js"
export * from "./AppraisalQuestion.vue?vue&type=script&lang=js"
import style0 from "./AppraisalQuestion.vue?vue&type=style&index=0&id=166bb80a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166bb80a",
  null
  
)

export default component.exports